import React, { useContext, useEffect, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import ProfileVerify from '../../../components/Templates/Site/ProfileVerify';
import { useTranslation } from 'react-i18next';
import CLabel from '../../../components/Common/CLabel';
import { ActionButton, Checkbox, DefaultButton, Dropdown, MessageBarType, PrimaryButton, Toggle } from '@fluentui/react';
import CTextBox from '../../../components/Common/CTextBox';
import PartyAgrupationItem from './PartyAgrupationItem';
import { useGetEdPConfiguration } from '../../../hooks/services/sPay/useOfEdPConfiguration';
import Loading from '../../../components/Templates/Site/Loading';
import { useDispatch, useSelector } from 'react-redux';
import MessageBoxInfoComplex from '../../../components/Common/Message/MessageBoxInfoComplex';
import MessageBox from '../../../components/Common/Message/MessageBox';
import { __EdP_Config_RolResponsableIngreso, __MessageTypes, __PartyAgrupationsPosition, enum__AppElementType, enum__PRIVILEGES, enum_CONTRACTPARTIE_FORM_MODE, enum_EDPCONFIG_PARTIE_GROUP_MODE } from '../../../common/Dictionaries';
import { isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty, isNullUndefinedOrEmptyOrZero, isNullUndefinedOrNegative, showMessage } from '../../../common/Helpers';
import { action_addEdpConfigPartyGroup, action_deleteEdpConfigPartyGroup, action_updateEdpConfigDI, action_updateEdpConfigObjectProperty, action_updateEdpConfigPartyGroup, action_updateEdpConfigPartyGroupConfig, action_updateEdPConfigurationErrorValidations } from '../../../reducers/actions/PAY/edpConfigActions';
import CValidator from '../../../components/Common/CValidator';
import { _checkSecurityUser } from '../../../common/Helpers/HLP_Security';
import { addEdpPartiGroup, deleteEdpPartiGroup, updatePayConfiguration } from '../../../services/sPay/edpConfig.service';
import { action_setBoardViewElementId } from '../../../reducers/actions/KPI/actions';
import { __onGoToBoardEP } from '../../../common/SystemRedirections';
import MainAppContext from '../../../MainAppContext';
import { __GetClientRoleCode } from '../../../common/CommonFuctions';
import { useGetUserPropsKpi } from '../../../hooks/services/sPrivilege/useOfPrivilege';

function ConfigureEdP(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const contextSite = useContext(MainAppContext);
    const { token: currentAuth } = useSelector((state) => state.auth);

    const [queryStringElementId, setQueryStringElementId] = useState(
        props.match.params.elementId !== null && props.match.params.elementId !== undefined && props.match.params.elementId !== "" ?
            props.match.params.elementId : null);

    const {
        _formMode: formMode,
        _firsLoad: firsLoad,
        _edpConfigObject: edpConfigObject,
        _edpConfigGetted: edpConfigGetted,
        _edpConfigErrorValidations: edpConfigErrorValidations,
        _edpOnPreparing: edpOnPreparing,
    } = useSelector((state) => state.edpConfigurationState);

    const { _elementId: elementId } = useSelector((state) => state.boardViewScope);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [objIsValidForm, setObjIsValidForm] = useState({
        isInValidElementId                      : false,
        isInValidCodContrato                    : false,
        isInValidEpMensual                      : false,
        isInValidSaldoRecursoNegativo           : false,
        isInValidAec                            : false,
        isInValidAdn                            : false,
        isInValidRfaUno                         : false,
        isInValidRfaDos                         : false,
        isInValidRfaTres                        : false,
        isInValidInconsistente                  : false,
        isInValidInconsistenteMensaje           : false,
        isInValidDiaCierrePeriodoEp             : false,
        isInValidPlazoEnvioEp                   : false,
        isInValidPlazoRevisionEp                : false,
        isInValidPlazoAprobarEp                 : false,
        isInValidIngresoManualFactorReajuste    : false,
        isInValidAutofacturacion                : false,
        isInValidPermiteDi                      : false,
        isInValidRolIngresoDi                   : false,
    });

    
    const [L_RFA, setL_RFA] = useState([]);

    const [partieGroupMode, setPartieGroupMode] = useState(enum_EDPCONFIG_PARTIE_GROUP_MODE.INSERT);
    const [objPartyGroup, setObjPartyGroup] = useState({id: null, name: null, position: null });
    const [objPartyGroupValidators, setObjPartyGroupValidators] = useState({ isValidName: undefined, isValidPosition: undefined });

    useGetEdPConfiguration(queryStringElementId, edpConfigObject, edpConfigGetted, setL_RFA);
    
    const [userPropsKpi, setUserPropsKpi] = useState({hasAccess : null, onlyObserver: null})
    useGetUserPropsKpi(7, null, queryStringElementId, currentAuth.token.userName, userPropsKpi, setUserPropsKpi)

    const aux_priv_canEdit = _checkSecurityUser(contextSite.onlyObserver, userPropsKpi, contextSite.securityProps, parseInt(queryStringElementId), enum__PRIVILEGES.EDP_CONFIG);
    const _priv_canEdit = edpOnPreparing === false && aux_priv_canEdit.mode === enum_CONTRACTPARTIE_FORM_MODE.CREATE && aux_priv_canEdit.value === true;

    const onSaveEdPConfiguration = () => {
        if (!isValidForm()) {    
            updatePayConfiguration(prepareFormToSave()).then((serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-requireddatanotset'))
        }
    };

    const prepareFormToSave = () => {
        const objToSave = {
            iteM_CONF_EP_CONTRATO: {
                id: edpConfigObject.iteM_CONF_EP_CONTRATO.id,
                elementId: edpConfigObject.iteM_CONF_EP_CONTRATO.elementId,
                codContrato: edpConfigObject.iteM_CONF_EP_CONTRATO.codContrato,
                epMensual: edpConfigObject.iteM_CONF_EP_CONTRATO.epMensual,
                saldoRecursoNegativo : edpConfigObject.iteM_CONF_EP_CONTRATO.saldoRecursoNegativo,
                aec: edpConfigObject.iteM_CONF_EP_CONTRATO.aec,
                ato: edpConfigObject.iteM_CONF_EP_CONTRATO.ato,
                adn: edpConfigObject.iteM_CONF_EP_CONTRATO.adn,
                rfaUno: edpConfigObject.iteM_CONF_EP_CONTRATO.rfaUno === -1 ? null : (edpConfigObject.iteM_CONF_EP_CONTRATO.rfaUno === 0 ? "" : edpConfigObject.iteM_CONF_EP_CONTRATO.rfaUno),
                rfaDos: edpConfigObject.iteM_CONF_EP_CONTRATO.rfaDos === -1 ? null : (edpConfigObject.iteM_CONF_EP_CONTRATO.rfaDos === 0 ? "" : edpConfigObject.iteM_CONF_EP_CONTRATO.rfaDos),
                rfaTres: edpConfigObject.iteM_CONF_EP_CONTRATO.rfaTres === -1 ? null : (edpConfigObject.iteM_CONF_EP_CONTRATO.rfaTres === 0 ? "" : edpConfigObject.iteM_CONF_EP_CONTRATO.rfaTres),
                inconsistente: edpConfigObject.iteM_CONF_EP_CONTRATO.inconsistente,
                inconsistenteMensaje: edpConfigObject.iteM_CONF_EP_CONTRATO.inconsistenteMensaje,
                diaCierrePeriodoEp: edpConfigObject.iteM_CONF_EP_CONTRATO.diaCierrePeriodoEp,
                plazoEnvioEp: edpConfigObject.iteM_CONF_EP_CONTRATO.plazoEnvioEp,
                plazoRevisionEp: edpConfigObject.iteM_CONF_EP_CONTRATO.plazoRevisionEp,
                plazoAprobarEp: edpConfigObject.iteM_CONF_EP_CONTRATO.plazoAprobarEp,
                ingresoManualFactorReajuste: edpConfigObject.iteM_CONF_EP_CONTRATO.ingresoManualFactorReajuste,
                autofacturacion: (edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion === null ? false : edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion),
                permiteDi: edpConfigObject.iteM_CONF_EP_CONTRATO.permiteDi,
                rolIngresoDi: edpConfigObject.iteM_CONF_EP_CONTRATO.rolIngresoDi,
            },
            //[##Se quita nombre_partida para que WAF no deniegue por caracteres especiales]
            l_PARTIDAS_CONFIGURACION: edpConfigObject.l_PARTIDAS_CONFIGURACION.map(({ nombre_partida, ...rest }) => rest),
            l_CONF_EP_DI: edpConfigObject.l_CONF_EP_DI,
            l_GRUPO: edpConfigObject.l_GRUPO,
        }

        return objToSave;
    };

    const onCancelEdpConfiguration = () => {
        window.location.href = `/EDP/${queryStringElementId}`;
    };

    const isValidForm = () => {
        let isInvalid = false;

        //objIsValidForm.isInValidElementId = isNullUndefinedOrEmpty(edpConfigObject.iteM_CONF_EP_CONTRATO.elementId);
        //isInvalid = !isInvalid ? objIsValidForm.isInValidElementId : isInvalid;

        //objIsValidForm.isInValidCodContrato = isNullUndefinedOrEmpty(edpConfigObject.iteM_CONF_EP_CONTRATO.codContrato);
        //isInvalid = !isInvalid ? objIsValidForm.isInValidCodContrato : isInvalid;

        //objIsValidForm.isInValidAutofacturacion = isNullUndefinedOrEmpty(edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion) || edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion === -1;
        //isInvalid = !isInvalid ? objIsValidForm.isInValidAutofacturacion : isInvalid;

        objIsValidForm.isInValidEpMensual = isNullUndefinedOrNegative(edpConfigObject.iteM_CONF_EP_CONTRATO.epMensual);
        isInvalid = !isInvalid ? objIsValidForm.isInValidEpMensual : isInvalid;

        objIsValidForm.isInValidSaldoRecursoNegativo = isNullUndefinedOrNegative(edpConfigObject.iteM_CONF_EP_CONTRATO.saldoRecursoNegativo);
        isInvalid = !isInvalid ? objIsValidForm.isInValidSaldoRecursoNegativo : isInvalid;

        objIsValidForm.isInValidPermiteDi = isNullUndefinedOrNegative(edpConfigObject.iteM_CONF_EP_CONTRATO.permiteDi);
        isInvalid = !isInvalid ? objIsValidForm.isInValidPermiteDi : isInvalid;

        objIsValidForm.isInValidDiaCierrePeriodoEp = isNullUndefinedOrNegative(edpConfigObject.iteM_CONF_EP_CONTRATO.diaCierrePeriodoEp);
        isInvalid = !isInvalid ? objIsValidForm.isInValidDiaCierrePeriodoEp : isInvalid;

        objIsValidForm.isInValidPlazoEnvioEp = isNullUndefinedOrNegative(edpConfigObject.iteM_CONF_EP_CONTRATO.plazoEnvioEp);
        isInvalid = !isInvalid ? objIsValidForm.isInValidPlazoEnvioEp : isInvalid;

        objIsValidForm.isInValidPlazoRevisionEp = isNullUndefinedOrNegative(edpConfigObject.iteM_CONF_EP_CONTRATO.plazoRevisionEp);
        isInvalid = !isInvalid ? objIsValidForm.isInValidPlazoRevisionEp : isInvalid;

        objIsValidForm.isInValidPlazoAprobarEp = isNullUndefinedOrNegative(edpConfigObject.iteM_CONF_EP_CONTRATO.plazoAprobarEp);
        isInvalid = !isInvalid ? objIsValidForm.isInValidPlazoAprobarEp : isInvalid;

        objIsValidForm.isInValidIngresoManualFactorReajuste = isNullUndefinedOrNegative(edpConfigObject.iteM_CONF_EP_CONTRATO.ingresoManualFactorReajuste);
        isInvalid = !isInvalid ? objIsValidForm.isInValidIngresoManualFactorReajuste : isInvalid;

        if (edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion === true) {
            objIsValidForm.isInValidAto = (edpConfigObject.iteM_CONF_EP_CONTRATO.ato === undefined);
            isInvalid = !isInvalid ? objIsValidForm.isInValidAec : isInvalid;
        }
        else {
            objIsValidForm.isInValidAec = (edpConfigObject.iteM_CONF_EP_CONTRATO.aec === undefined);
            isInvalid = !isInvalid ? objIsValidForm.isInValidAec : isInvalid;
        }

        //objIsValidForm.isInValidRolIngresoDi = (edpConfigObject.iteM_CONF_EP_CONTRATO.rolIngresoDi === undefined);
        //isInvalid = !isInvalid ? objIsValidForm.isInValidRolIngresoDi : isInvalid;

        if (edpConfigObject.iteM_CONF_EP_CONTRATO.permiteDi === true) {
            isInvalid = !isInvalid ? (edpConfigObject.l_CONF_EP_DI.filter(x => x.activo === true).length === 0 ? true : isInvalid) : isInvalid;
        }

        isInvalid = !isInvalid ? edpConfigObject.l_PARTIDAS_CONFIGURACION.some(partie => {
            return isNullUndefinedOrEmptyOrZero(partie.partidaGrupoId) || (isNullUndefined(partie.ato));
        }) : isInvalid;

        isInvalid = !isInvalid ? edpConfigObject.l_CONF_EP_DI.some(di => {
            return (isNullUndefined(di.aad));
        }) : isInvalid;

        isInvalid = !isInvalid ? edpConfigObject.l_GRUPO.length === 0 : isInvalid;

        setObjIsValidForm({ ...objIsValidForm });

        return isInvalid
    };

    const updateGlobalMessageLocally = (show) => {
        if (!show) {
            dispatch(action_updateEdPConfigurationErrorValidations(null));
        }
    };

    const preparePartieGroupToSave = (item) => {
        return {
            id: item.id !== null ? (item.id < 0 ? 0 : item.id) : 0,
            codContrato: edpConfigObject.iteM_CONF_EP_CONTRATO.codContrato,
            elementId: edpConfigObject.iteM_CONF_EP_CONTRATO.elementId,
            posicion: item.position,
            title: item.name,
            vigente: true
        }
    };

    const onSavePartyGroup = () => {
        const isValidName = !isNullUndefinedOrEmpty(objPartyGroup.name) &&
                            (partieGroupMode === enum_EDPCONFIG_PARTIE_GROUP_MODE.INSERT || (edpConfigObject.l_GRUPO.find(x => x.title === objPartyGroup.name) === undefined));
        const isValidPosition = !isNullUndefinedOrEmpty(objPartyGroup.position) &&
                                (partieGroupMode === enum_EDPCONFIG_PARTIE_GROUP_MODE.INSERT || (edpConfigObject.l_GRUPO.find(x => x.title === objPartyGroup.position) === undefined));

        setObjPartyGroupValidators({
            isValidName: isValidName,
            isValidPosition: isValidPosition
        });
        
        if (edpConfigObject.l_GRUPO.length < 5) {
            showMessage(setMessageConfig, false, null, null);

            if ((isValidName && isValidPosition)) {
                if (objPartyGroup.position <= 5) {
                    if (edpConfigObject.l_GRUPO.filter(x => x.title.indexOf(objPartyGroup.name) === -1)) {
                        if (!isNullUndefinedOrEmptyOrZero(objPartyGroup.id) && objPartyGroup.id > 0) {
                            addEdpPartiGroup(queryStringElementId, preparePartieGroupToSave(objPartyGroup)).then((serviceResponse) => {
                                if (serviceResponse.data.succeeded) {
                                    dispatch(action_updateEdpConfigPartyGroup(
                                        objPartyGroup.id,
                                        {
                                            id: objPartyGroup.id,
                                            codContrato: edpConfigObject.iteM_CONF_EP_CONTRATO.codContrato,
                                            posicion: objPartyGroup.position,
                                            title: objPartyGroup.name,
                                            vigente: true
                                        }
                                    ));  
                                    setPartieGroupMode(enum_EDPCONFIG_PARTIE_GROUP_MODE.INSERT);
                                }
                                else {
                                    dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']))
                                    setPartieGroupMode(enum_EDPCONFIG_PARTIE_GROUP_MODE.INSERT);
                                }
                            }).catch(() => {
                                dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']))
                                setPartieGroupMode(enum_EDPCONFIG_PARTIE_GROUP_MODE.INSERT);
                            });
                        }
                        else {
                            addEdpPartiGroup(queryStringElementId, preparePartieGroupToSave(objPartyGroup)).then((serviceResponse) => {
                                if (serviceResponse.data.succeeded) {
                                    if (serviceResponse.data.data.result) {
                                        dispatch(action_addEdpConfigPartyGroup(
                                            {
                                                id: serviceResponse.data.data.itemId,
                                                codContrato: edpConfigObject.iteM_CONF_EP_CONTRATO.codContrato,
                                                posicion: objPartyGroup.position,
                                                title: objPartyGroup.name,
                                                vigente: true
                                            }
                                        ));
                                        setPartieGroupMode(enum_EDPCONFIG_PARTIE_GROUP_MODE.INSERT);
                                    }
                                    else {
                                        if (serviceResponse.data.data.l_validations.length > 0) {
                                            dispatch(action_updateEdPConfigurationErrorValidations(serviceResponse.data.data.l_validations))
                                            setPartieGroupMode(enum_EDPCONFIG_PARTIE_GROUP_MODE.EDIT);
                                        }
                                        else {
                                            dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']))
                                            setPartieGroupMode(enum_EDPCONFIG_PARTIE_GROUP_MODE.EDIT);
                                        }
                                    }
                                }
                                else {
                                    dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']))
                                    setPartieGroupMode(enum_EDPCONFIG_PARTIE_GROUP_MODE.EDIT);
                                }
                            }).catch(() => {
                                dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']))
                                setPartieGroupMode(enum_EDPCONFIG_PARTIE_GROUP_MODE.EDIT);
                            });
                        }
                        setObjPartyGroup({id: undefined, name: undefined, position: undefined })
                    }
                    else {
                        dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-existingpartygroup']))
                    }
                }
                else {
                    dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-partygroupposition1to5']))
                }
            }
            else {
                dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-requireddatanotset']))
            }
            
        }
        else {
            dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-partygroupslimiterror']))
        }
    };

    const onCancelSavePartyGroup = () => {
        setPartieGroupMode(enum_EDPCONFIG_PARTIE_GROUP_MODE.INSERT);
        setObjPartyGroup({id: undefined, name: undefined, position: undefined })
    }

    const onChangeEdPMonthPay = (ev, item) => {
        dispatch(action_updateEdpConfigObjectProperty('epMensual', item.key));
    };

    const onChangeEdPNegativeBalance = (ev, item) => {
        dispatch(action_updateEdpConfigObjectProperty('saldoRecursoNegativo', item.key));
    };

    const onChangePartyGroupName = (controlValue, inputParam_TextBoxName) => {
        setObjPartyGroup(prevState => ({
            ...prevState,
            [inputParam_TextBoxName]: controlValue
        }));

        setObjPartyGroupValidators(prevState => ({
            ...prevState,
            isValidName: !isNullOrEmpty(controlValue)
        }));
    };

    const onChangePartyGroupPosition = (ev, item) => {
        setObjPartyGroup(prevState => ({
            ...prevState,
            position: item.key
        }));

        setObjPartyGroupValidators(prevState => ({
            ...prevState,
            isValidPosition: !isNullOrEmpty(item.key)
        }));
    };

    const onSetPartyGroupToEdit = (item) => {
        setPartieGroupMode(enum_EDPCONFIG_PARTIE_GROUP_MODE.EDIT);
        setObjPartyGroup(item);
    };

    const onDeletePartyGroup = (itemId) => {
        if (edpConfigObject.l_GRUPO.length > 1) {
            deleteEdpPartiGroup(queryStringElementId, itemId).then((serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    if (serviceResponse.data.data.result) {
                        dispatch(action_deleteEdpConfigPartyGroup(itemId));
                    }
                    else {
                        if (serviceResponse.data.data.l_validations.length > 0) {
                            dispatch(action_updateEdPConfigurationErrorValidations(serviceResponse.data.data.l_validations))
                        }
                        else {
                            dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']))
                        }
                    }
                }
                else {
                    dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']))
                }
            }).catch(() => {
                dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-operationerror']))
            });
        }
        else {
            dispatch(action_updateEdPConfigurationErrorValidations(['data-lang-msg-partygroupunicrule']))
        }
    };

    const onAutoFactChange = (e, checked) => {
        dispatch(action_updateEdpConfigObjectProperty('autofacturacion', checked));
    };

    const onChangeTexboxValue = (controlValue, inputParam_TextBoxName) => {
        dispatch(action_updateEdpConfigObjectProperty(inputParam_TextBoxName, controlValue));
    };

    const onChangeEdPResponsibleEntryRole = (ev, item) => {
        const currentObject = __EdP_Config_RolResponsableIngreso.find(x => x.key === item.key);
        const valueToSave = !isNullUndefined(currentObject) ? (item.key === -1 ? null : currentObject.text) : undefined;
        dispatch(action_updateEdpConfigObjectProperty('rolIngresoDi', valueToSave));
    };

    const onChangeEdPATO_to_AEC = (ev, item) => {
        const currentObject = edpConfigObject.l_ATO.find(x => x.id === item.key);
        const valueToSave = !isNullUndefined(currentObject) ? (item.key === -1 ? null : currentObject.code) : undefined;
        dispatch(action_updateEdpConfigObjectProperty('ato', valueToSave));
    };

    const onCanChangeAllowsIncrDeduct = (e, checked) => {
        dispatch(action_updateEdpConfigObjectProperty('permiteDi', checked));
    };

    const onChangeEdPPartyAgrupation = (ev, item, party) => {
        party.partidaGrupoId = item.key;
        dispatch(action_updateEdpConfigPartyGroupConfig(party.id, party));
    };

    const onChangeEdPPartyATO_AEC = (ev, item, party) => {
        const currentObject = (edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion ? edpConfigObject.l_AECs : edpConfigObject.l_ATO).find(x => x.id === item.key);
        party.ato = !isNullUndefined(currentObject) ? (item.key === -1 ? null : currentObject.code) : undefined;
        dispatch(action_updateEdpConfigPartyGroupConfig(party.id, party));
    };

    const onChangeEdPPartyAAD = (ev, item, increase, propertyNameId) => {
        const currentObject = edpConfigObject.l_AAD.find(x => x.id === item.key);
        increase.aad = !isNullUndefined(currentObject) ? (item.key === -1 ? null : currentObject.code) : undefined;
        dispatch(action_updateEdpConfigDI(increase[propertyNameId], increase, propertyNameId));
    };

    const onActiveChanged = (ev, checked, obj_di, propertyNameId) => {
        obj_di.activo = checked;
        dispatch(action_updateEdpConfigDI(obj_di[propertyNameId], obj_di, propertyNameId));
    };

    const onEdPRfaChange = (e, checked, rfaObj) => {
        const nextChecked = !!checked;

        setL_RFA(prev => {
            // 1) aplicar cambio al que clickeaste
            let next = prev.map(item =>
            item.id === rfaObj.id ? { ...item, checked: nextChecked } : item
            );

            // 2) cascada hacia la derecha SOLO cuando se descheckea
            if (rfaObj.configPropertyName === "rfaUno" && !nextChecked) {
            next = next.map(item =>
                (item.configPropertyName === "rfaDos" || item.configPropertyName === "rfaTres")
                ? { ...item, checked: false }
                : item
            );
            }

            if (rfaObj.configPropertyName === "rfaDos" && !nextChecked) {
            next = next.map(item =>
                item.configPropertyName === "rfaTres"
                ? { ...item, checked: false }
                : item
            );
            }

            // 3) sync Redux según estado final (consistente)
            const rfa1 = next.find(x => x.configPropertyName === "rfaUno")?.checked ?? false;
            const rfa2 = next.find(x => x.configPropertyName === "rfaDos")?.checked ?? false;
            const rfa3 = next.find(x => x.configPropertyName === "rfaTres")?.checked ?? false;

            dispatch(action_updateEdpConfigObjectProperty("rfaUno", rfa1 ? "RFA1" : null));
            dispatch(action_updateEdpConfigObjectProperty("rfaDos", rfa2 ? "RFA2" : null));
            dispatch(action_updateEdpConfigObjectProperty("rfaTres", rfa3 ? "RFA3" : null));

            return next;
        });
    };
    
    const onChangeEdPManualAdd = (ev, item) => {
        dispatch(action_updateEdpConfigObjectProperty('ingresoManualFactorReajuste', item.key));
    };

    const manipulateList = (list) => {
        if (list.filter(x => x.key === -1).length === 0) {
            list.unshift({key: -1, text: t('data-lang-lbl-select')})
        }

        return list;
    };

    const getValidDropDownAADValue = (storedValue) => {
        const currentObject = edpConfigObject.l_AAD.find(x => x.code === storedValue);
        const correctValue = (currentObject !== undefined) ? (storedValue === -1 ? -1 : currentObject.id) : -1;
        return correctValue;
    };

    const getValidDropDownAECATOValue = (storedValue) => {
        const currentObject =  (edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion ?  edpConfigObject.l_AECs :  edpConfigObject.l_ATO).find(x => x.code === storedValue);
        const correctValue = (currentObject !== undefined) ? (storedValue === -1 ? -1 : currentObject.id) : -1;
        return correctValue;
    };

    const getValidDropDownAECValue = (storedValue) => {
        const currentObject = __EdP_Config_RolResponsableIngreso.find(x => x.text === storedValue);
        const correctValue = (currentObject !== undefined) ? (storedValue === "" ? -1 : currentObject.key) : -1;
        return correctValue;
    };

    const getValidDropDownATOValue = (storedValue) => {
        const currentObject = edpConfigObject.l_ATO.find(x => x.code === storedValue);
        const correctValue = (currentObject !== undefined) ? (storedValue === -1 ? -1 : currentObject.id) : -1;
        return correctValue;
    };

    const BlockearCaracteresNoNoumericos = (value) => {
        const regex = /^-?\d*$/;

        if (regex.test(value) || value === '') {
            return true;
        }
        else {
            return false;
        }
    };

    const onValidateClosingDayPeriod = () => {
        const value = edpConfigObject.iteM_CONF_EP_CONTRATO.diaCierrePeriodoEp;

        if (value < 1 || value > 31) {
            return true;
        }
        else {
            return false;
        }
    };

    const onValidateValueFrom1To10 = (propertyName) => {
        const value = edpConfigObject.iteM_CONF_EP_CONTRATO[propertyName];

        if (value < 1 || value > 10) {
            return true;
        }
        else {
            return false;
        }
    };

    useEffect(() => {
        if (isNullUndefinedOrEmpty(elementId)) {
            dispatch(action_setBoardViewElementId(queryStringElementId));
        }
    }, [elementId]);

    return (
    <Card className='h-100'>
        <Card.Header className='d-flex'>     
            <Card.Title className="d-flex justify-content-between">
                <h4><b>{t('data-lang-boxname-configureedp')}</b></h4>
            </Card.Title>
            <ActionButton style={{position: "absolute", right: "0px"}} iconProps={{iconName: "View"}} text={t('data-lang-lbl-baktoedp')} onClick={() => __onGoToBoardEP(queryStringElementId)} />
        </Card.Header>
        <Card.Footer>
            <MessageBox  
                inputParam_Message={ messageConfig.message }
                inputParam_Display={ messageConfig.showMessage }
                inputParam_MessageType={ messageConfig.messageType }
                inputParam_SetterMessage={ setMessageConfig }
            />
            {
                edpConfigObject && (edpConfigObject.iteM_CONF_EP_CONTRATO.permiteDi === true && edpConfigObject.l_CONF_EP_DI.filter(x => x.activo === true).length === 0) &&
                <MessageBox
                    inputParam_Message={ t('data-lang-msg-edpidrequired') }
                    inputParam_Display={ true }
                    inputParam_MessageType={ 'warning' }
                    inputParam_SetterMessage={ null }
                />
            }
            {
                !isNullUndefined(edpConfigErrorValidations) && edpConfigErrorValidations.length > 0 &&
                    <MessageBoxInfoComplex
                        inputParam_Width="100%"
                        inputParam_TranslateText={true}
                        inputParam_Display={true}
                        inputParam_ShowClose={true}
                        inputParam_MessageType={__MessageTypes.WARNING}
                        inputParam_CustomSetterMessage={true}
                        inputParam_Message={ edpConfigErrorValidations }
                        inputParam_SetterMessage={updateGlobalMessageLocally}
                    />
            }
        </Card.Footer>
        <Card.Body className="pt-2 w-100">
            {
                firsLoad === false &&
                <Loading inputParam_ShowLoading={true}/>
            }
            {
                firsLoad === true && edpConfigGetted === true && edpConfigObject !== null &&
                <>
                    <Row className='h-100 mt-2'>
                        <Col className='text-start me-1 mx-3'>
                            <Row className='border-bottom'>
                                <h4>{t('data-lang-boxname-edpconfig-edpperiodicity')}</h4>
                            </Row>
                            <Row className='my-3'>
                                <Col>
                                    <b>{ t('data-lang-lbl-monthlypaymentstatus') }</b>
                                    {
                                        _priv_canEdit &&
                                        <>
                                            <Dropdown
                                                placeholder={t('data-lang-btn-select')}
                                                options={manipulateList([{ key: true, text: t('data-lang-lbl-yes') }, { key: false, text: t('data-lang-lbl-no') }])}
                                                selectedKey={edpConfigObject.iteM_CONF_EP_CONTRATO.epMensual}
                                                onChange={(event, option) => onChangeEdPMonthPay(event, option)}
                                                checkable
                                                disabled={false}
                                                styles={ {title: { height: "27px" }} }
                                                className="mb-1"
                                            />
                                            {
                                                (isNullUndefinedOrNegative(edpConfigObject.iteM_CONF_EP_CONTRATO.epMensual) || edpConfigObject.iteM_CONF_EP_CONTRATO.epMensual === -1) &&
                                                <CValidator isInValid={true} inValidText={t('data-lang-msg-required')} />
                                            }
                                        </>
                                    }
                                    {
                                        !_priv_canEdit &&
                                        <>
                                            <br/>
                                            <CLabel labelValue={edpConfigObject.iteM_CONF_EP_CONTRATO.epMensual ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')} />
                                        </>
                                    }
                                </Col>
                            </Row>
                        </Col>
                        <Col className='text-start ms-1 mx-3'>
                            <Row className='border-bottom'>
                                <h4>{t('data-lang-boxname-edpconfig-balancespertyresource')}</h4>
                            </Row>
                            <Row className='my-3'>
                                <Col>
                                    <b>{ t('data-lang-lbl-allowsnegativebalances') }</b>
                                    {
                                        _priv_canEdit &&
                                        <>
                                            <Dropdown
                                                placeholder={t('data-lang-btn-select')}
                                                options={manipulateList([{ key: true, text: t('data-lang-lbl-yes') }, { key: false, text: t('data-lang-lbl-no') }])}
                                                selectedKey={edpConfigObject.iteM_CONF_EP_CONTRATO.saldoRecursoNegativo}
                                                onChange={(event, option) => onChangeEdPNegativeBalance(event, option)}
                                                checkable
                                                disabled={false}
                                                styles={ {title: { height: "27px" }} }
                                                className="mb-1"
                                            />
                                            {
                                                (isNullUndefinedOrNegative(edpConfigObject.iteM_CONF_EP_CONTRATO.saldoRecursoNegativo) || edpConfigObject.iteM_CONF_EP_CONTRATO.saldoRecursoNegativo === -1) &&
                                                <CValidator isInValid={true} inValidText={t('data-lang-msg-required')} />
                                            }
                                        </>
                                    }
                                    {
                                        !_priv_canEdit &&
                                        <>
                                            <br/>
                                            <CLabel labelValue={edpConfigObject.iteM_CONF_EP_CONTRATO.saldoRecursoNegativo ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')} />
                                        </>
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='h-100 mt-5'>
                        <Col>
                            <Row className='border-bottom'>
                                <h4>{t('data-lang-boxname-edpconfig-partygroups')}</h4>
                            </Row>
                            <Row className='border m-3'>
                                {
                                    _priv_canEdit &&
                                    <Col className='text-start'>
                                        <Row className='my-3'>
                                            <Col>
                                                <CTextBox
                                                    textBoxName='name'
                                                    labelText={t('data-lang-lbl-groupingname')}
                                                    controlValue={objPartyGroup.name}
                                                    setterControlValue={onChangePartyGroupName}
                                                    isInValid={objPartyGroupValidators.isValidName === undefined ? false : ((edpConfigObject.l_GRUPO.find(x => x.title === objPartyGroup.name) === undefined) && !objPartyGroupValidators.isValidName)}
                                                />
                                                {
                                                    (partieGroupMode === enum_EDPCONFIG_PARTIE_GROUP_MODE.INSERT && objPartyGroup.id === 0 && (objPartyGroupValidators.isValidName === undefined ? false : ((edpConfigObject.l_GRUPO.find(x => x.title === objPartyGroup.name) !== undefined)))) &&
                                                    <CValidator isInValid={true} inValidText={t('data-lang-msg-elementexist')} />
                                                }
                                            </Col>
                                        </Row>
                                        <Row className='my-3'>
                                            <Col xl={12}>
                                                <b>{ t('data-lang-lbl-groupingposition') }</b>
                                            </Col>
                                            <Col>
                                                <Dropdown
                                                    placeholder={t('data-lang-btn-select')}
                                                    options={manipulateList(__PartyAgrupationsPosition.map(x => { return {key: x.id, text: x.position} }))}
                                                    selectedKey={!isNullUndefinedOrEmpty(objPartyGroup.position) ? objPartyGroup.position :-1}
                                                    onChange={(event, option) => onChangePartyGroupPosition(event, option)}
                                                    checkable
                                                    disabled={false}
                                                    styles={ {title: { height: "27px" }} }
                                                    className="mb-1"
                                                />
                                                {
                                                    !isNullUndefinedOrNegative(objPartyGroup.position) && objPartyGroupValidators.isValidPosition === undefined ? false : !objPartyGroupValidators.isValidPosition &&
                                                    <CValidator isInValid={objPartyGroupValidators.isValidPosition === undefined ? false : !objPartyGroupValidators.isValidPosition} />
                                                }
                                                {
                                                    (partieGroupMode === enum_EDPCONFIG_PARTIE_GROUP_MODE.INSERT && objPartyGroup.id === 0 && (objPartyGroupValidators.isValidPosition === undefined ? false : ((edpConfigObject.l_GRUPO.find(x => x.posicion === objPartyGroup.position) !== undefined)))) &&
                                                    <CValidator isInValid={true} inValidText={t('data-lang-msg-elementexist')} />
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col></Col>
                                            <Col className='col-auto me-auto mb-2'>
                                                <PrimaryButton className='mx-1' text={ partieGroupMode === enum_EDPCONFIG_PARTIE_GROUP_MODE.INSERT ? t('data-lang-btn-add') : t('data-lang-btn-save')} onClick={onSavePartyGroup} />
                                                {
                                                    partieGroupMode === enum_EDPCONFIG_PARTIE_GROUP_MODE.EDIT &&
                                                    <DefaultButton className='mx-1' text={ t('data-lang-btn-cancel')} onClick={onCancelSavePartyGroup} />
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                <Col className='text-start'>
                                    <Row>
                                        <Col className='my-3' xl={4}><b>{t('data-lang-boxname-edpconfig-existinggroups')}</b></Col>
                                        <Col className='my-3'>
                                            { 
                                                edpConfigObject.l_GRUPO.map((x, index) =>
                                                    <Row key={x.id}>
                                                        <Col>
                                                            <PartyAgrupationItem
                                                                inputParam_ElementIndex={index}
                                                                inputParam_ElementItem={x}
                                                                inputParam_EditMode={_priv_canEdit}
                                                                inputParam_SetPartyGroupToEdit={onSetPartyGroupToEdit}
                                                                inputParam_DeletePartyGroup={onDeletePartyGroup}
                                                                inputParam_NormalizedPosition={__PartyAgrupationsPosition.find(z => z.id === x.posicion).position}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='h-100 mt-5'>
                        <Col>
                            <Row className='border-bottom'>
                                <h4>{t('data-lang-boxname-edpconfig-edppreparation')}</h4>
                            </Row>
                            <Row className='border m-3'>
                                <Col className='text-start'>
                                    <Row>
                                        <Col className='mt-3 my-3'>
                                            <b>{ t('data-lang-lbl-selfbilling') }</b>
                                            {
                                                _priv_canEdit &&
                                                <Toggle
                                                    checked={ edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion ? edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion : false }
                                                    onChange={ onAutoFactChange }
                                                    role="checkbox"
                                                    onText={ t('data-lang-lbl-yes') }
                                                    offText={ t('data-lang-lbl-no')}
                                                    styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                                />
                                            }
                                            {
                                                !_priv_canEdit &&
                                                <>
                                                    <br/>
                                                    <CLabel labelValue={edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')} />
                                                </>
                                            }
                                        </Col>
                                        <Col className='mt-0 my-3'>
                                            {
                                                _priv_canEdit &&
                                                <>
                                                    {
                                                        edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion &&
                                                        <>
                                                            <b>{ __GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'ATO') }</b>
                                                            <Dropdown
                                                                placeholder={t('data-lang-btn-select')}
                                                                options={manipulateList(edpConfigObject.l_ATO.map(x => {return {key: x.id, text: x.name}}))}
                                                                selectedKey={getValidDropDownATOValue(edpConfigObject.iteM_CONF_EP_CONTRATO.ato)}
                                                                onChange={(event, option) => onChangeEdPATO_to_AEC(event, option)}
                                                                checkable
                                                                disabled={false}
                                                                styles={ {title: { height: "27px" }} }
                                                                className="mb-1"
                                                            />
                                                            {
                                                                (isNullUndefined(edpConfigObject.iteM_CONF_EP_CONTRATO.ato) || edpConfigObject.iteM_CONF_EP_CONTRATO.ato === -1) &&
                                                                <CValidator isInValid={true} inValidText={t('data-lang-msg-required')} />
                                                            }
                                                        </>
                                                    }
                                                    {
                                                        !edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion &&
                                                        <>
                                                            <CLabel labelText={__GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'AEC')} />
                                                            <br/>
                                                            <CLabel labelValue={edpConfigObject.aec} />
                                                        </>
                                                    }
                                                </>
                                            }
                                            {
                                                !_priv_canEdit &&
                                                <>
                                                    <br/>
                                                    <CLabel labelText={__GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'AEC')} labelValue={edpConfigObject.aec} />
                                                </>
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className={_priv_canEdit ? 'pt-2 my-3' : 'mt-0 my-3'}>
                                            <b>{ t('data-lang-lbl-allowsincreasesdeductions') }</b>
                                            {
                                                _priv_canEdit &&
                                                <Toggle
                                                    checked={ edpConfigObject.iteM_CONF_EP_CONTRATO.permiteDi }
                                                    onChange={ onCanChangeAllowsIncrDeduct }
                                                    role="checkbox"
                                                    onText={ t('data-lang-lbl-yes') }
                                                    offText={ t('data-lang-lbl-no')}
                                                    styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                                />
                                            }
                                            {
                                                !_priv_canEdit &&
                                                !_priv_canEdit &&
                                                <>
                                                    <br/>
                                                    <CLabel labelValue={edpConfigObject.iteM_CONF_EP_CONTRATO.permiteDi ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')} />
                                                </>
                                            }
                                        </Col>
                                        <Col className='mt-0 my-3'>
                                        </Col>
                                        {
                                            false &&
                                            <Col className='mt-0 my-3'>
                                                <b>{ t('data-lang-lbl-rolresponsibleinsert') }</b>
                                                {
                                                    _priv_canEdit &&
                                                    <>
                                                        {
                                                            edpConfigObject.iteM_CONF_EP_CONTRATO.permiteDi &&
                                                            <>
                                                                <Dropdown
                                                                    placeholder={t('data-lang-btn-select')}
                                                                    options={manipulateList(__EdP_Config_RolResponsableIngreso)}
                                                                    selectedKey={getValidDropDownAECValue(edpConfigObject.iteM_CONF_EP_CONTRATO.rolIngresoDi)}
                                                                    onChange={(event, option) => onChangeEdPResponsibleEntryRole(event, option)}
                                                                    checkable
                                                                    disabled={false}
                                                                    styles={ {title: { height: "27px" }} }
                                                                    className="mb-1"
                                                                />
                                                                {
                                                                    (isNullUndefined(edpConfigObject.iteM_CONF_EP_CONTRATO.rolIngresoDi) || edpConfigObject.iteM_CONF_EP_CONTRATO.rolIngresoDi === -1) &&
                                                                    <CValidator isInValid={true} inValidText={t('data-lang-msg-required')} />
                                                                }
                                                            </>
                                                        }
                                                        {
                                                            !edpConfigObject.iteM_CONF_EP_CONTRATO.permiteDi &&
                                                            <Dropdown
                                                                placeholder={t('data-lang-btn-select')}
                                                                disabled={true}
                                                                styles={ {title: { height: "27px" }} }
                                                                className="mb-1"
                                                            />
                                                        }
                                                    </>
                                                }
                                                {
                                                    !_priv_canEdit &&
                                                    <>
                                                        <br/>
                                                        <CLabel labelValue={edpConfigObject.iteM_CONF_EP_CONTRATO.rolIngresoDi} />
                                                    </>
                                                }
                                            </Col>
                                        }
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='h-100 mt-5'>
                        <Col>
                            <Row className='border-bottom'>
                                <Col><h4>{t('data-lang-boxname-edpconfig-edprevision')}</h4></Col>
                            </Row>
                            <Row className='border m-3'>
                                <Col xl={2} className='my-auto'><h5>{t('data-lang-lbl-parties')}</h5></Col>
                                <Col>
                                    <table className='w-100'>
                                        <thead>
                                            <tr>
                                                <th className='w-25'>{t('data-lang-lbl-code')}</th>          
                                                <th className='w-25'>{t('data-lang-lbl-contractpartie-partiename')}</th>          
                                                <th className='w-25'>{t('data-lang-lbl-grouping')}</th>          
                                                <th className='w-25'>
                                                    { edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion && __GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'AEC') }
                                                    { !edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion && __GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'ATO') }
                                                </th>          
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                edpConfigObject.l_PARTIDAS_CONFIGURACION.map(party =>
                                                    <tr key={party.id}>
                                                        <td>{party.codigo_partida}</td>
                                                        <td>{party.nombre_partida}</td>
                                                        <td className='d-flex'>
                                                        {
                                                            _priv_canEdit &&
                                                            <>
                                                                <Dropdown
                                                                    placeholder={t('data-lang-btn-select')}
                                                                    options={manipulateList(edpConfigObject.l_GRUPO.filter(x => x.vigente === true).map(x => {return {key: x.id, text: x.title}}))}
                                                                    selectedKey={party.partidaGrupoId}
                                                                    onChange={(event, option) => onChangeEdPPartyAgrupation(event, option, party)}
                                                                    checkable
                                                                    disabled={false}
                                                                    styles={ {title: { height: "27px" }} }
                                                                    className="mb-1 w-100"
                                                                />
                                                                {
                                                                    (isNullUndefinedOrNegative(party.partidaGrupoId) || party.partidaGrupoId === -1) &&
                                                                    <CValidator isInValid={true} inValidText={` ${t('data-lang-msg-required')}`} />
                                                                }
                                                            </>
                                                        }
                                                        {
                                                            !_priv_canEdit &&
                                                            <CLabel labelValue={
                                                                manipulateList(edpConfigObject.l_GRUPO.filter(x => x.vigente === true).map(x => {return {key: x.id, text: x.title}})).find(x => x.key === party.partidaGrupoId)?.text ?
                                                                manipulateList(edpConfigObject.l_GRUPO.filter(x => x.vigente === true).map(x => {return {key: x.id, text: x.title}})).find(x => x.key === party.partidaGrupoId).text : t('data-lang-btn-select') }
                                                            />
                                                        }
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <Row>
                                                                    <Col className='d-flex'>
                                                                    {
                                                                        _priv_canEdit &&
                                                                        <>
                                                                            {
                                                                                edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion &&
                                                                                <>
                                                                                    <Dropdown
                                                                                        placeholder={t('data-lang-btn-select')}
                                                                                        options={manipulateList(edpConfigObject.l_AECs.map(x => {return {key: x.id, text: x.name}}))}
                                                                                        selectedKey={getValidDropDownAECATOValue(party.ato)}
                                                                                        onChange={(event, option) => onChangeEdPPartyATO_AEC(event, option, party)}
                                                                                        checkable
                                                                                        disabled={false}
                                                                                        styles={ {title: { height: "27px" }} }
                                                                                        className="mb-1 w-100"
                                                                                    />
                                                                                    {
                                                                                        (isNullUndefined(party.ato) || party.ato === -1) &&
                                                                                        <CValidator isInValid={true} inValidText={` ${t('data-lang-msg-required')}`} />
                                                                                    }
                                                                                </>
                                                                            }
                                                                            {
                                                                                !edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion &&
                                                                                <>
                                                                                    <Dropdown
                                                                                        placeholder={t('data-lang-btn-select')}
                                                                                        options={manipulateList(edpConfigObject.l_ATO.map(x => {return {key: x.id, text: x.name}}))}
                                                                                        selectedKey={getValidDropDownAECATOValue(party.ato)}
                                                                                        onChange={(event, option) => onChangeEdPPartyATO_AEC(event, option, party)}
                                                                                        checkable
                                                                                        disabled={false}
                                                                                        styles={ {title: { height: "27px" }} }
                                                                                        className="mb-1 w-100"
                                                                                    />
                                                                                    {
                                                                                        (isNullUndefined(party.ato) || party.ato === -1) &&
                                                                                        <CValidator isInValid={true} inValidText={t('data-lang-msg-required')} />
                                                                                    }
                                                                                </>
                                                                            }
                                                                        </>
                                                                    }
                                                                    {
                                                                        !_priv_canEdit &&
                                                                        <>
                                                                            {
                                                                                edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion &&
                                                                                <CLabel labelValue={
                                                                                    !isNullUndefined(edpConfigObject.l_AECs.find(x => x.key === party.ato)) ? edpConfigObject.l_AECs.find(x => x.key === party.ato).name : ''} />
                                                                            }
                                                                            {
                                                                                !edpConfigObject.iteM_CONF_EP_CONTRATO.autofacturacion &&
                                                                                <CLabel labelValue={!isNullUndefined(edpConfigObject.l_ATO.find(x => x.code === party.ato)) ? edpConfigObject.l_ATO.find(x => x.code === party.ato).name : ''} />
                                                                            }
                                                                        </>
                                                                    }
                                                                    </Col> 
                                                                </Row> 
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                            <Row className='border m-3'>
                                <Col xl={2} className='my-auto'><h5>{t('data-lang-lbl-increments')}</h5></Col>
                                <Col>
                                    <table className='w-100'>
                                        <thead>
                                            <tr>
                                                <th className='w-33'></th>          
                                                <th className='w-33'>{t('data-lang-lbl-active')}</th>          
                                                <th className='w-33'>{__GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'AAD')}</th>                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                edpConfigObject.l_CONF_EP_DI.filter(x => x.incrementoId !== null).map(increase =>
                                                    <tr key={increase.id}>
                                                        <td>{increase.title}</td>
                                                        <td>
                                                            {
                                                                _priv_canEdit ?
                                                                <>
                                                                    

                                                                            {
                                                                                increase.selection === false &&
                                                                                <Checkbox checked={increase.activo} disabled={true} />
                                                                            }
                                                                            {
                                                                                increase.selection === true &&
                                                                                <Checkbox checked={increase.activo} onChange={(ev, checked) => onActiveChanged(ev, checked, increase, 'incrementoId')} />
                                                                            }
                                                                    
                                                                </>
                                                                :
                                                                <CLabel labelValue={increase.activo ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')} />
                                                            }
                                                        </td>
                                                        <td className='d-flex'>
                                                            {
                                                                _priv_canEdit &&
                                                                <>
                                                                    <Dropdown
                                                                        placeholder={t('data-lang-btn-select')}
                                                                        options={manipulateList(edpConfigObject.l_AAD.map(x => {return {key: x.id, text: x.name}}))}
                                                                        selectedKey={getValidDropDownAADValue(increase.aad)}
                                                                        onChange={(event, option) => onChangeEdPPartyAAD(event, option, increase, 'incrementoId')}
                                                                        checkable
                                                                        disabled={false}
                                                                        styles={ {title: { height: "27px" }} }
                                                                        className="mb-1 w-100"
                                                                    />
                                                                    {
                                                                        (isNullUndefined(increase.aad) || increase.aad === -1) &&
                                                                        <CValidator isInValid={true} inValidText={` ${t('data-lang-msg-required')}`} />
                                                                    }
                                                                </>
                                                            }
                                                            {
                                                                !_priv_canEdit &&
                                                                <CLabel labelValue={manipulateList(edpConfigObject.l_AAD.map(x => {return {key: x.id, text: x.name}})).find(x => x.key === getValidDropDownAADValue(increase.aad)).text} />
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                            
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                            <Row className='border m-3'>
                                <Col xl={2} className='my-auto'><h5>{t('data-lang-lbl-deductions')}</h5></Col>
                                <Col>
                                    <table className='w-100'>
                                        <thead>
                                            <tr>
                                                <th className='w-33'></th>          
                                                <th className='w-33'>{t('data-lang-lbl-active')}</th>          
                                                <th className='w-33'>{__GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'AAD')}</th>                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                edpConfigObject.l_CONF_EP_DI.filter(x => x.deduccionId !== null).map(deduction =>
                                                    <tr key={deduction.id}>
                                                        <td>{deduction.title}</td>
                                                        <td>
                                                            {
                                                                _priv_canEdit ?
                                                                <>

                                                                            {
                                                                                deduction.selection === false &&
                                                                                <Checkbox checked={deduction.activo} disabled={true} />
                                                                            }
                                                                            {
                                                                                deduction.selection === true &&
                                                                                <Checkbox checked={deduction.activo} onChange={(ev, checked) => onActiveChanged(ev, checked, deduction, 'deduccionId')} />
                                                                            }

                                                                </>
                                                                :
                                                                <CLabel labelValue={deduction.activo ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')} />
                                                            }
                                                        </td>
                                                        <td className='d-flex'>
                                                            {
                                                                _priv_canEdit &&
                                                                <>
                                                                    <Dropdown
                                                                        placeholder={t('data-lang-btn-select')}
                                                                        options={manipulateList(edpConfigObject.l_AAD.map(x => {return {key: x.id, text: x.name}}))}
                                                                        selectedKey={getValidDropDownAADValue(deduction.aad)}
                                                                        onChange={(event, option) => onChangeEdPPartyAAD(event, option, deduction, 'deduccionId')}
                                                                        checkable
                                                                        disabled={false}
                                                                        styles={ {title: { height: "27px" }} }
                                                                        className="mb-1 w-100"
                                                                    />
                                                                    {
                                                                        (isNullUndefined(deduction.aad) || deduction.aad === -1) &&
                                                                        <CValidator isInValid={true} inValidText={` ${t('data-lang-msg-required')}`} />
                                                                    }
                                                                </>
                                                            }
                                                            {
                                                                !_priv_canEdit &&
                                                                <CLabel labelValue={manipulateList(edpConfigObject.l_AAD.map(x => {return {key: x.id, text: x.name}})).find(x => x.key === getValidDropDownAADValue(deduction.aad)).text} />
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='h-100 mt-5'>
                        <Col>
                            <Row className='border-bottom'>
                                <Col><h4>{t('data-lang-boxname-edpconfig-edpapproval')}</h4></Col>
                            </Row>
                            <Row className='border m-3'>
                                <Col className='my-auto'>
                                    <CLabel labelText={__GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'ADN')} labelValue={edpConfigObject.adn} />
                                </Col>
                                {
                                    L_RFA && L_RFA.map((x) => {
                                        const rfa1Checked = L_RFA.find(r => r.configPropertyName === "rfaUno")?.checked ?? false;
                                        const rfa2Checked = L_RFA.find(r => r.configPropertyName === "rfaDos")?.checked ?? false;
                                        const disabled =
                                            (x.configPropertyName === "rfaDos" && !rfa1Checked) ||
                                            (x.configPropertyName === "rfaTres" && !rfa2Checked);

                                        return (
                                            <Col key={x.id} className="my-3 col d-flex align-items-center gap-2">
                                            <b className="mb-0">{`${__GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, x.roleName)}${x.index}`}</b>

                                            {_priv_canEdit && (
                                                <Toggle
                                                checked={x.checked}
                                                disabled={disabled}
                                                onChange={(event, checked) => onEdPRfaChange(event, checked, x)}
                                                onText={t("data-lang-lbl-yes")}
                                                offText={t("data-lang-lbl-no")}
                                                styles={{ root: { paddingTop: "14px", display: "flex" } }}
                                                />
                                            )}
                                            </Col>
                                        );
                                    })
                                }
                            </Row>
                        </Col>
                    </Row>
                    <Row className='h-100 mt-5'>
                        <Col>
                            <Row className='border-bottom'>
                                <Col><h4>{t('data-lang-boxname-edpconfig-edpdeadlines')}</h4></Col>
                            </Row>
                            <Row className='border m-3'>
                                <Col>
                                    <Row className='mt-3 my-3'>
                                        <Col>
                                            {
                                                _priv_canEdit &&
                                                <>
                                                    <CTextBox
                                                        textBoxName='diaCierrePeriodoEp'
                                                        labelText={t('data-lang-lbl-closingdayepperiod')}
                                                        controlValue={edpConfigObject.iteM_CONF_EP_CONTRATO.diaCierrePeriodoEp}
                                                        setterControlValue={onChangeTexboxValue}
                                                        isInValid={isNullUndefinedOrEmpty(edpConfigObject.iteM_CONF_EP_CONTRATO.diaCierrePeriodoEp)}
                                                        onlyNumbers={true}
                                                        onlyNumbersCustomEvent={BlockearCaracteresNoNoumericos}
                                                    />
                                                    <CValidator isInValid={onValidateClosingDayPeriod()} isInValidText={ t('data-lang-msg-monthdayinvalid') }  />
                                                </>
                                            }
                                            {
                                                !_priv_canEdit &&
                                                <CLabel labelText={t('data-lang-lbl-closingdayepperiod')} labelValue={edpConfigObject.iteM_CONF_EP_CONTRATO.diaCierrePeriodoEp} />
                                            }
                                        </Col>
                                        <Col>
                                            {
                                                _priv_canEdit &&
                                                <>
                                                    <CTextBox
                                                        textBoxName='plazoEnvioEp'
                                                        labelText={t('data-lang-lbl-deadlinesendingep')}
                                                        controlValue={edpConfigObject.iteM_CONF_EP_CONTRATO.plazoEnvioEp}
                                                        setterControlValue={onChangeTexboxValue}
                                                        isInValid={isNullUndefinedOrEmpty(edpConfigObject.iteM_CONF_EP_CONTRATO.plazoEnvioEp)}
                                                        onlyNumbers={true}
                                                        onlyNumbersCustomEvent={BlockearCaracteresNoNoumericos}
                                                    />
                                                    <CValidator isInValid={onValidateValueFrom1To10('plazoEnvioEp')} isInValidText={ t('data-lang-msg-numbernotless1ormore10') }  />
                                                </>
                                            }
                                            {
                                                !_priv_canEdit &&
                                                <CLabel labelText={t('data-lang-lbl-deadlinesendingep')} labelValue={edpConfigObject.iteM_CONF_EP_CONTRATO.plazoEnvioEp} />
                                            }
                                        </Col>
                                    </Row>
                                    <Row className='mt-3 my-3'>
                                        <Col>
                                            {
                                                _priv_canEdit &&
                                                <>
                                                    <CTextBox
                                                        textBoxName='plazoRevisionEp'
                                                        labelText={t('data-lang-lbl-deadlinereviewingep')}
                                                        controlValue={edpConfigObject.iteM_CONF_EP_CONTRATO.plazoRevisionEp}
                                                        setterControlValue={onChangeTexboxValue}
                                                        isInValid={isNullUndefinedOrEmpty(edpConfigObject.iteM_CONF_EP_CONTRATO.plazoRevisionEp)}
                                                        onlyNumbers={true}
                                                        onlyNumbersCustomEvent={BlockearCaracteresNoNoumericos}
                                                    />
                                                    <CValidator isInValid={onValidateValueFrom1To10('plazoRevisionEp')} isInValidText={ t('data-lang-msg-numbernotless1ormore10') }  />
                                                </>
                                            }
                                            {
                                                !_priv_canEdit &&
                                                <CLabel labelText={t('data-lang-lbl-deadlinereviewingep')} labelValue={edpConfigObject.iteM_CONF_EP_CONTRATO.plazoRevisionEp} />
                                            }
                                        </Col>
                                        <Col>
                                            {
                                                _priv_canEdit &&
                                                <>
                                                    <CTextBox
                                                        textBoxName='plazoAprobarEp'
                                                        labelText={t('data-lang-lbl-deadlineapprovingep')}
                                                        controlValue={edpConfigObject.iteM_CONF_EP_CONTRATO.plazoAprobarEp}
                                                        setterControlValue={onChangeTexboxValue}
                                                        isInValid={isNullUndefinedOrEmpty(edpConfigObject.iteM_CONF_EP_CONTRATO.plazoAprobarEp)}
                                                        onlyNumbers={true}
                                                        onlyNumbersCustomEvent={BlockearCaracteresNoNoumericos}
                                                    />
                                                    <CValidator isInValid={onValidateValueFrom1To10('plazoAprobarEp')} isInValidText={ t('data-lang-msg-numbernotless1ormore10') }  />
                                                </>
                                            }
                                            {
                                                !_priv_canEdit &&
                                                <CLabel labelText={t('data-lang-lbl-deadlineapprovingep')} labelValue={edpConfigObject.iteM_CONF_EP_CONTRATO.plazoAprobarEp} />
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='h-100 mt-5'>
                        <Col>
                            <Row className='border-bottom'>
                                <Col><h4>{t('data-lang-boxname-edpconfig-manualentryadjustmentfactors')}</h4></Col>
                            </Row>
                            <Row className='border m-3'>
                                <Col>
                                    <Row className='mt-3 my-3'>
                                        <Col>
                                            <b>{ t('data-lang-lbl-manualentry') }</b>
                                            {
                                                _priv_canEdit &&
                                                <>
                                                    <Dropdown
                                                        placeholder={t('data-lang-btn-select')}
                                                        options={manipulateList([{ key: true, text: t('data-lang-lbl-yes') }, { key: false, text: t('data-lang-lbl-no') }])}
                                                        selectedKey={edpConfigObject.iteM_CONF_EP_CONTRATO.ingresoManualFactorReajuste}
                                                        onChange={(event, option) => onChangeEdPManualAdd(event, option)}
                                                        checkable
                                                        disabled={false}
                                                        styles={ {title: { height: "27px" }} }
                                                        className="mb-1"
                                                    />
                                                    {
                                                        (isNullUndefinedOrNegative(edpConfigObject.iteM_CONF_EP_CONTRATO.ingresoManualFactorReajuste) || edpConfigObject.iteM_CONF_EP_CONTRATO.ingresoManualFactorReajuste === -1) &&
                                                        <CValidator isInValid={true} inValidText={t('data-lang-msg-required')} />
                                                    }
                                                </>
                                            }
                                            {
                                                !_priv_canEdit &&
                                                <>
                                                    <br/>
                                                    <CLabel labelValue={manipulateList([{ key: true, text: t('data-lang-lbl-yes') }, { key: false, text: t('data-lang-lbl-no') }]).find(x => x.key === edpConfigObject.iteM_CONF_EP_CONTRATO.ingresoManualFactorReajuste).text} />
                                                </>
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {
                        edpConfigObject && (edpConfigObject.iteM_CONF_EP_CONTRATO.permiteDi === true && edpConfigObject.l_CONF_EP_DI.filter(x => x.activo === true).length === 0) &&
                        <MessageBox
                            inputParam_Message={ t('data-lang-msg-edpidrequired') }
                            inputParam_Display={ true }
                            inputParam_MessageType={ 'warning' }
                            inputParam_SetterMessage={ null }
                        />
                    }
                    {
                        _priv_canEdit &&
                        <>
                            <Row>
                                <Col className='col-auto me-auto mb-2'>
                                    <PrimaryButton className='mx-1' text={t('data-lang-btn-save')} onClick={onSaveEdPConfiguration} />
                                    <DefaultButton className='mx-1' text={t('data-lang-btn-cancelback')} onClick={onCancelEdpConfiguration} />
                                </Col>
                            </Row>
                            <Card.Footer className='p-0'>
                                <MessageBox  
                                    inputParam_Message={ messageConfig.message }
                                    inputParam_Display={ messageConfig.showMessage }
                                    inputParam_MessageType={ messageConfig.messageType }
                                    inputParam_SetterMessage={ setMessageConfig }
                                />
                                {
                                    !isNullUndefined(edpConfigErrorValidations) && edpConfigErrorValidations.length > 0 &&
                                        <MessageBoxInfoComplex
                                            inputParam_Width="100%"
                                            inputParam_TranslateText={true}
                                            inputParam_Display={true}
                                            inputParam_ShowClose={true}
                                            inputParam_Message={ edpConfigErrorValidations }
                                            inputParam_MessageType={__MessageTypes.WARNING}
                                            inputParam_CustomSetterMessage={true}
                                            inputParam_SetterMessage={updateGlobalMessageLocally}
                                        />
                                }
                            </Card.Footer>
                        </>
                    }
                </>
            }
            {
                firsLoad === true && (edpConfigGetted === null || edpConfigGetted === false) &&
                <>
                    {
                        edpConfigErrorValidations === null &&
                        <MessageBox
                            inputParam_Width="100%"
                            inputParam_MessageType={__MessageTypes.ERROR}
                            inputParam_Display={true}
                            inputParam_Message={ t('data-lang-msg-erroroccurred') }
                        />
                    }
                </>
            }
        </Card.Body>
    </Card>);
}

export default ConfigureEdP;